module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAAXNSR0IArs4c6QAAAG1JREFUGBmVkNEJgDAMREMXEES/nM8ZXFRwHL3XmhKkVA0cDZdHL62Z2SCt0ig9C48ZTG5Onbs0Y9xFj8cMON/khsMRwqtpcXBogFopskusA0D0dZUE8ac+RbPo22MmUnl6a/GYsgH2PpybgJYLBYgljZHObYwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/ic_cancel_small.png
// module id = xOP/
// module chunks = 1